<div
  ctExtractionOcrFormInput
  [activeField]="currentActiveField()"
  class="relative flex h-full max-h-full min-h-0 flex-col gap-4">
  <h3 class="rounded-xl bg-white p-5 font-bold shadow-md">Auftragserfassung</h3>
  @for (section of sections(); track $index) {
    <div class="flex rounded-xl bg-white p-3 shadow-md">
      <span
        class="sticky top-4 bottom-4 col-span-2 rotate-180 self-center text-center font-medium"
        style="writing-mode: vertical-rl">
        {{ section.label }}
      </span>
      <div class="mx-1.5 border-l border-gray-200"></div>
      <ct-extraction-field-group-extraction-view
        class="w-full"
        [isConsolidation]="false"
        [fieldGroupModel]="section"
        [isActiveSection]="currentActiveSection()?.key === section.key"
        [showHeader]="false"
        [currentFieldModel]="currentActiveFieldModel()"
        [prefillResults]="initialFieldData()"
        [focusInputs]="true"
        [directValueChangeFields]="directValueChangeFields.get(section.key) ?? []"
        (currentExtractionFieldChange)="onCurrentFormFieldChange(section, $event)"
        (valueChange)="saveFieldGroupData($event)"
        (statusChange)="changeSectionStatus.emit({ section: section, status: $event })"
        (directValueChanged)="onDirectValueChanged($event)" />
    </div>

    @if (section.label === 'Auftrag' && displayExistierendeAuftraegeSelection()) {
      <ct-extraction-existing-auftraege-selection
        [searchParameters]="existingAuftraegeSearchParameters()"
        [metaData]="ctBatchStore.ctBatch.metaData" />
    }
  }
</div>
